import React from 'react';

type Props = {
  isHidden?: boolean,
  text: string,
  value: string | number,
}

export default function BasicCard({
  isHidden, text, value,
}: Props) {
  const textClasses = [
    'ds-client-report-text',
    'd-flex',
    'align-items-center',
    'justify-content-center',
    'flex-grow',
    isHidden ? 'ds-client-report-text--hidden' : '',
  ].join(' ');

  return (
    <div className="ds-client-report-card d-flex">
      <div className="ds-client-report-value align-items-center justify-content-center d-flex py-3 px-4">
        <div>{value}</div>
      </div>
      <div
        className={`${textClasses} flex-fill`}
      >
        {text}
      </div>
    </div>
  );
}
